import { jsx as _jsx } from "react/jsx-runtime";
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
var rootElement = document.getElementById("root");
export var dfApiUrl = (rootElement === null || rootElement === void 0 ? void 0 : rootElement.dataset.apiurl) || "";
var layout = (rootElement === null || rootElement === void 0 ? void 0 : rootElement.dataset.layout) || "";
createRoot(document.getElementById('root')).render(_jsx(StrictMode, { children: _jsx(App, { apiUrl: dfApiUrl, layout: layout }) }));
